const baseImage =
  "https://minibrew-development.s3.amazonaws.com/static/devices/base.png";
const kegImage =
  "https://minibrew-development.s3.amazonaws.com/static/devices/keg.png";

export { baseImage, kegImage };
